import React from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { Container, Typography, Link, Box } from '@mui/material';

function NotFound() {
    return (
        <Container maxWidth="sm">
            <Box sx={{ my: 8, textAlign: 'center' }}>
                <Typography id="not-found-header" variant="h4" component="h1" gutterBottom>
                    Page not found
                </Typography>
                <Link component={RouterLink} to="/" id="not-found-home-link">
                    Back to sign in
                </Link>
            </Box>
        </Container>
    );
}

export default NotFound;
